import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 29.7.",
  "description": "",
  "published": "2011-07-29T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-29-7/swizec/2022"],
  "categories": "Caffeine, Coffee, Drink, Health, Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/Caffeinated_spiderwebs2.jpg",
        "alt": "Caffeine has a significant effect on spiders, ...",
        "title": "Caffeine has a significant effect on spiders, ..."
      }}></img></p>
    <p>{`This marks the first in what I hope to make a quick daily note on this blog.`}</p>
    <p>{`As an exercise in learning something every day and considering that people tend to remember things much better when writing them down, I will take a few minutes every evening to write the two things I have learned that day.`}</p>
    <p>{`The first thing that I learned today was that I am a huge huge caffeine addict. Decided to go on a caffeine diet for a couple of days and today was possibly the most miserable I have been in quite a while. Zombied through the day.`}</p>
    <p>{`Another thing that I learned is that taking two hours off in the middle of the afternoon to watch some shows when you're feeling like your head is about to roll off your shoulders and into a gutter full of poo ... the world doesn't come crawling to a halt. The work waits for you. And nobody but yourself thinks any worse of you. Taking a break `}<em parentName="p">{`works`}</em>{` bitchz.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://wiki.answers.com/Q/Is_caffeine_against_the_word_of_wisdom"
        }}>{`Is caffeine against the word of wisdom`}</a>{` (wiki.answers.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.losethattyre.co.uk/five-benefits-of-giving-up-caffeine/"
        }}>{`Five Benefits of Giving up Caffeine`}</a>{` (losethattyre.co.uk)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=405429b1-af19-4f52-80a1-1e0caa8e1a4d",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      